import React from 'react'
import { featureFlags } from '../config/featureFlags'
import HealthRecordsLoadErrorCard from '../features/home/components/HealthRecordsLoadErrorCard'
import HealthRecordsManagementCard from '../features/home/components/HealthRecordsManagementCard'
import HomeContentGrid from '../features/home/components/HomeContentGrid'
import HomeFaq from '../features/home/components/HomeFaq'
import HomeFooter from '../features/home/components/HomeFooter'
import HomeHero from '../features/home/components/HomeHero'
import OutstandingItemsCard from '../features/home/components/OutstandingItemsCard'
import OutstandingItemsLoadingCard from '../features/home/components/OutstandingItemsLoadingCard'
import SupportCard from '../features/home/components/SupportCard'
import TestingProgressCard from '../features/home/components/TestingProgressCard'
import { useHomeGreetingName } from '../features/home/hooks/useHomeGreetingName'
import { useOutstandingSecondaryConsents } from '../features/home/hooks/useOutstandingSecondaryConsents'

const Home: React.FC = () => {
  const firstName = useHomeGreetingName(true)
  const outstandingItems = useOutstandingSecondaryConsents(true, featureFlags.enableFastenConnect)
  const hasOutstandingItems = outstandingItems.items.length > 0 || outstandingItems.connectSubjects.length > 0

  const outstandingItemsContent = outstandingItems.loading ? (
    <OutstandingItemsLoadingCard />
  ) : hasOutstandingItems ? (
    <OutstandingItemsCard items={outstandingItems.items} connectSubjects={outstandingItems.connectSubjects} />
  ) : undefined
  const healthRecordsLoadErrorCard =
    !outstandingItems.loading && outstandingItems.healthRecordsLoadFailed ? <HealthRecordsLoadErrorCard /> : undefined
  const outstandingItemsCard =
    outstandingItemsContent || healthRecordsLoadErrorCard ? (
      <>
        {outstandingItemsContent}
        {healthRecordsLoadErrorCard}
      </>
    ) : undefined
  const healthRecordsManagementCard =
    !outstandingItems.loading && outstandingItems.hasManageableHealthRecords ? (
      <HealthRecordsManagementCard />
    ) : undefined

  return (
    <div className="space-y-6 pb-2">
      <HomeHero firstName={firstName} />
      <TestingProgressCard />
      <HomeContentGrid
        outstandingItemsCard={outstandingItemsCard}
        healthRecordsManagementCard={healthRecordsManagementCard}
        faq={<HomeFaq />}
        support={<SupportCard />}
      />
      <HomeFooter />
    </div>
  )
}

export default Home
